const baseURL = `${process.env.REACT_APP_BASE_URL}/api/websites`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to save normal website
const UpdateEUFlagDomainApi = async (
    accessToken: string, // access token
    websiteId: number, // website id
    is_eu_script_show: number, // is_eu_script_show flag
    is_eu_script_show_first: number, // is_eu_script_show_first flag
    no_required_eu: number, // no_required_eu flag
): Promise<any> => {

    const url = `${baseURL}/eu-flag-update`;

    const data = new FormData();
    data.append("id", websiteId.toString());
    data.append("is_eu_script_show", is_eu_script_show.toString())
    data.append("is_eu_script_show_first", is_eu_script_show_first.toString())
    data.append("no_required_eu", no_required_eu.toString())

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }

}

export { UpdateEUFlagDomainApi }